import React from 'react'
import {
    Placeholder,
withSitecoreContext
} from '@sitecore-jss/sitecore-jss-react'
import './index.scss'

const SplitGalleryContainer = (props) => {
return (
    <section className={"split-gallery-container"}>
      <div className="cp-row">
        <div className={`col-6 one-col-section left-col`}>
          <Placeholder name="jss-splitleft" rendering={props.rendering} />
        </div>
        <div className={`col-6 one-col-section right-col`}>
          <Placeholder name="jss-splitright" rendering={props.rendering} />
        </div>
      </div>
    </section>
);
};

export default withSitecoreContext()(SplitGalleryContainer)
  